// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "ondemand/static/8b50f6e88/js/" + ({"77":"LiveTvPage","98":"ErrorPage","439":"Page","496":"CollectionPage","509":"WatchPageV2","778":"PersonPage"}[chunkId] || chunkId) + ".chunk.js";
};